/*

class to generate address

http://www.hl7.org/fhir/datatypes.html#Address

{
  "state" : "<string>", // Sub-unit of country (abbreviations ok)
  "country" : "<string>", // Country (e.g. can be ISO 3166 2 or 3 letter code)
  "city" : "<string>", // Name of city, town etc.
  "line" : ["<string>"], // Street name, number, direction & P.O. Box etc.
  "type" : "<code>", // postal | physical | both
  "text" : "<string>", // Text representation of the address
  "district" : "<string>", // District name (aka county)
  "postalCode" : "<string>", // Postal code for area
  "period" : { Period } // Time period when address was/is in use
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { ADDRESS_TYPES } = require('@bcm/constants');
const { joiValidateObj } = require('../datastructComponents');

// Create schema
const schema = {
  state: Joi.string().valid().required(),
  country: Joi.string().required(),
  city: Joi.string().required(),
  line: Joi.array().items( Joi.string().required() ),
  type: Joi.string().valid( ...Object.keys(ADDRESS_TYPES)).optional(),
  text: Joi.string().optional(),
  district: Joi.string().optional(),
  postalCode: Joi.string().optional(),
  periodStart: Joi.string().optional(),
  periodEnd: Joi.string().optional(),
};

// Define class
class Address {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Address = Address;
exports.addressSchema = schema;